// extracted by mini-css-extract-plugin
export default {"modal":"AuthModal_modal__9BQuF","registrationFormModal":"AuthModal_registrationFormModal__9w0Ta","closeBtnContainer":"AuthModal_closeBtnContainer__0wLGV"};